import api from 'api';
import axiosDBClient from 'axiosDBClient';
import { setQlikAuth } from 'services/qlik.service';

export const generateQtoken = async (userId) => {
  try {
    const response = await api.get(`qlik/token?userId=${userId}`);
    if (!response.statusText === 'OK') {
      throw new Error('Could not get token');
    }
    const data = await response.data;
    setQlikAuth(data?.token, data?.cookie);
  } catch (error) {
    console.error('Error generating Qtoken:', error);
    throw error;
  }
};

export const getWrapperObj = async (roleId) => {
  const wrapperdata = async (roleId) => {
    const response = await axiosDBClient.get(`v2/wrapper`, {
      params: { roleId },
    });
    if (response.data.error) {
      throw new Error('wrapper not loaded');
    }

    return response.data.result;
  };

  try {
    const data = await wrapperdata(roleId);
    return data;
  } catch (error) {}
};
